module.exports = __webpack_public_path__ + "img/pro_three_1.b3be6884.jpg";